import React, { useEffect, useState } from 'react'
import Spinwheel from '../../components/common/Spinwheel';
import toast from 'react-hot-toast';
import { Link, useNavigate, } from 'react-router-dom';
import { getInventoryApi, getInventoryReportApi, getvendorsApi } from '../../utils/ApiEndpointFunctions';
import { useFormik } from 'formik';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import { inventoryReportFilterInitialValue, inventoryReportValidationSchema } from '../../utils/Validation';
import { useUserContext } from '../../context/userContext';
import DatePicker from "react-datepicker";
import Select from 'react-select';

function InventoryReport(props) {
   const location = useLocation();
   const {langPreference} = useUserContext()
   const initialFilterValue = location?.state?.path === "/inventory/report" && location.state?.filterValue
      ? location.state.filterValue
      : inventoryReportFilterInitialValue
   const [search,setSearch] = useState(false)
   const [inventoryReportList, setInventoryReportList] = useState([])
   const [loading, setLoading] = useState(false)
   const [appliedFilters, setAppliedFilters] = useState(initialFilterValue)
   const [vendors, setVendors] = useState([])
   const [items, setItems] = useState([])
   const navigate = useNavigate();

   const getQuantity = (item) => Number(item?.addedQty ?? item?.quantity ?? 0)

   const getMovement = (item) => {
      if (item?.type === "gin") return "out"
      if (item?.type === "goods-return") return "return"
      return "in"
   }

   const getReference = (item) => {
      if (item?.type === "challan" && item?.challan?._id) {
         return {
            label: item?.challan?.challanNumber,
            to: `/challan/view/${item.challan._id}`,
         }
      }

      if (item?.type === "gin" && item?.gin?._id) {
         return {
            label: item?.gin?.ginNumber,
            to: `/gin/view/${item.gin._id}`,
         }
      }

      if (item?.type === "goods-return" && item?.goodsreturn?.returnFromGin?._id) {
         return {
            label: item?.goodsreturn?.returnFromGin?.ginNumber,
            to: `/gin/view/${item.goodsreturn.returnFromGin._id}`,
         }
      }

      return { label: "Opening stock", to: "" }
   }

   const getSource = (item) => {
      const sourceLabels = {
         self: "Self",
         challan: "Challan",
         gin: "GIN",
         "goods-return": "Goods Return",
      }
      return sourceLabels[item?.type] || item?.type || "-"
   }

   const getItemSummary = (movements = []) => movements.reduce((summary, item) => {
      const quantity = getQuantity(item)
      if (getMovement(item) === "out") summary.totalOut += quantity
      else summary.totalIn += quantity
      return summary
   }, { totalIn: 0, totalOut: 0 })

   const getReport = async(vendorId, selectedDate, inventoryId)=>{
      setLoading(true)
      try {
          const res = await getInventoryReportApi(vendorId, selectedDate, inventoryId)
          if (res.status === 200) {
            setInventoryReportList(res?.data?.data?.data)
          }
          setLoading(false)
      } catch (error) {
          setLoading(false)
          toast.error(error?.response?.data?.message || "Something went wrong")
          console.log("error", error);
      }
   }

   const filterFormik = useFormik({
      initialValues: initialFilterValue,
      validationSchema: inventoryReportValidationSchema(langPreference), 
      onSubmit: async (values) => {
          let vendorId = values?.vendor?.value
          let inventoryId = values?.item?.value
          let selectedDate = `${values?.to ? new Date(values.to).getTime() + "-" : ""}${values?.from ? new Date(values.from).getTime() : ""}`
          setSearch(true)
          setAppliedFilters(values)
          getReport(vendorId, selectedDate, inventoryId)
      }
	  })

  const handleReset = () => {
      filterFormik.setValues(inventoryReportFilterInitialValue)
      setAppliedFilters(inventoryReportFilterInitialValue)
      navigate("/inventory/report", { replace: true })
      getReport("", "", "")
      setSearch(false)
  }

   const loadFilterOptions = async () => {
      try {
         const [vendorResponse, itemResponse] = await Promise.all([
            getvendorsApi("", "", "", "Sub-Contractor"),
            getInventoryApi(),
         ])

         if (vendorResponse.status === 200) {
            setVendors(vendorResponse.data?.data?.vendors?.map(vendor => ({
               label: vendor.name,
               value: vendor?._id,
            })) || [])
         }

         if (itemResponse.status === 200) {
            setItems(itemResponse.data?.data?.data?.map(item => ({
               label: item.name,
               value: item?._id,
            })) || [])
         }
      } catch (error) {
         console.log(error)
      }
   }

      useEffect(() => {
          loadFilterOptions()
          if (location?.state?.path == "/inventory/report" && location.state?.filterValue) {
              filterFormik.handleSubmit()
          }
      }, [location])


   return (
      <>
         <div className="main-content">
            <div className="container-fluid">
               <div className="row">
                  <div className="main-content">
                     <div className='report-header'>
                           <div>
                            {props.type !== "dashboard" && <div className="dash-nav1 dash-nav-report">
                                <form className="inventory-report-toolbar" onSubmit={filterFormik.handleSubmit}>
                                    <div className="inventory-report-toolbar__title">
                                       <span onClick={() => navigate(-1)} className="back cursor-pointer">
                                          <i className="bi bi-chevron-left"></i> {langPreference?.back || "Back"}
                                       </span>
                                       <h3 className="mb-0 font-blue">{langPreference?.inventory_report || "Inventory Report"}</h3>
                                    </div>
                                    <div className="inventory-report-toolbar__filters">
                                       <div className="inventory-report-toolbar__field inventory-report-toolbar__field--date">
                                          <label htmlFor="inventory-report-date">{langPreference?.date || "Date"}</label>
                                          <DatePicker
                                             id="inventory-report-date"
                                             selectsRange
                                             dateFormat="dd/MM/yyyy"
                                             className={`form-control cursor-pointer ${((filterFormik.touched?.to && filterFormik.errors?.to) || (filterFormik.touched?.from && filterFormik.errors?.from)) ? "border-danger" : ""}`}
                                             startDate={filterFormik.values?.to || null}
                                             endDate={filterFormik.values?.from || null}
                                             onChange={(dates) => {
                                                filterFormik.setFieldValue("to", dates[0])
                                                filterFormik.setFieldValue("from", dates[1])
                                             }}
                                             isClearable
                                             placeholderText={`${langPreference?.from || "From"} - ${langPreference?.to || "To"}`}
                                             showDisabledMonthNavigation
                                          />
                                       </div>
                                       <div className="inventory-report-toolbar__field">
                                          <label>{langPreference?.subcontractor_name || "Sub-contractor"}</label>
                                          <Select
                                             className="inventory-report-toolbar__select"
                                             classNamePrefix="select"
                                             value={filterFormik.values?.vendor || null}
                                             placeholder={langPreference?.select || "Select"}
                                             isSearchable
                                             isClearable
                                             name="vendor"
                                             options={vendors}
                                             onChange={(value) => filterFormik.setFieldValue("vendor", value || "")}
                                          />
                                       </div>
                                       <div className="inventory-report-toolbar__field">
                                          <label>{langPreference?.item || "Item"}</label>
                                          <Select
                                             className="inventory-report-toolbar__select"
                                             classNamePrefix="select"
                                             value={filterFormik.values?.item || null}
                                             placeholder={langPreference?.select || "Select"}
                                             isSearchable
                                             isClearable
                                             name="item"
                                             options={items}
                                             onChange={(value) => filterFormik.setFieldValue("item", value || "")}
                                          />
                                       </div>
                                       <div className="inventory-report-toolbar__actions">
                                          <button className="btn btn-dark" type="button" disabled={!Object.values(filterFormik.values).filter(Boolean).length} onClick={handleReset}>
                                             {langPreference?.reset_filter || "Reset filter"}
                                          </button>
                                          <button className="btn btn-primary" type="submit">
                                             {langPreference?.apply || "Apply"}
                                          </button>
                                       </div>
                                    </div>
                                </form>
                            </div>}
                            </div>
                           </div>
                         
                     {loading ? <div className='d-flex align-items-center justify-content-center mt-4'>
                        <Spinwheel />
                     </div> :
                        <div className='inventory-report-content pt-5'>
                           {inventoryReportList?.length==0 ?  <h4 className='text-center mt-5 pt-5'>{search ? langPreference?.data_not_found ||  "Data not found" : langPreference?.please_select_date || "Please select date range"} </h4> :
                           inventoryReportList?.map(ele => {
                              const movements = ele?.inOutStock || []
                              const summary = getItemSummary(movements)
                              return <section className="inventory-ledger" key={ele?._id || ele?.name}>
                                 <div className="inventory-ledger__summary">
                                    <div className="inventory-ledger__identity">
                                       <span className="inventory-ledger__eyebrow">{langPreference?.inventory_item || "Inventory item"}</span>
                                       <h4>{ele?.name || "-"}</h4>
                                    </div>
                                    <div className="inventory-ledger__metrics">
                                       <div className="inventory-ledger__metric inventory-ledger__metric--available">
                                          <span>{langPreference?.current_available || "Current Available"}</span>
                                          <strong>{Number(ele?.availableQty || 0).toLocaleString("en-IN")}</strong>
                                       </div>
                                       <div className="inventory-ledger__metric inventory-ledger__metric--in">
                                          <span>{langPreference?.total_in || "Total In"}</span>
                                          <strong>+{summary.totalIn.toLocaleString("en-IN")}</strong>
                                       </div>
                                       <div className="inventory-ledger__metric inventory-ledger__metric--out">
                                          <span>{langPreference?.total_out || "Total Out"}</span>
                                          <strong>-{summary.totalOut.toLocaleString("en-IN")}</strong>
                                       </div>
                                    </div>
                                 </div>
                                 <div className="table-responsive inventory-ledger__table-wrap">
                                    <table className="table inventory-ledger__table mb-0">
                                       <thead>
                                          <tr>
                                             <th scope="col">{langPreference?.date || "Date"}</th>
                                             <th scope="col">{langPreference?.reference || "Reference"}</th>
                                             <th scope="col">{langPreference?.approved_by || "Approved By"}</th>
                                             <th scope="col">{langPreference?.source || "Source"}</th>
                                             <th scope="col">{langPreference?.movement || "Movement"}</th>
                                             <th scope="col" className="text-end">{langPreference?.qty || "Quantity"}</th>
                                          </tr>
                                       </thead>
                                       <tbody>
                                          {movements.length > 0 ? movements.map((item, index) => {
                                             const movement = getMovement(item)
                                             const reference = getReference(item)
                                             const quantity = getQuantity(item)
                                             return <tr key={item?._id || `${item?.type}-${item?.approvedOn}-${index}`}>
                                                <td>{item?.approvedOn ? moment(item.approvedOn).format("DD/MM/YYYY") : "-"}</td>
                                                <td>
                                                   {reference.to ? <Link to={reference.to} state={{ path: "/inventory/report", filterValue: appliedFilters }}>{reference.label}</Link> : reference.label}
                                                </td>
                                                <td className="text-capitalize">{`${item?.approvedBy?.firstName || ""} ${item?.approvedBy?.lastName || ""}`.trim() || "-"}</td>
                                                <td>{getSource(item)}</td>
                                                <td><span className={`inventory-movement inventory-movement--${movement}`}>{movement.toUpperCase()}</span></td>
                                                <td className={`text-end inventory-quantity inventory-quantity--${movement}`}>{movement === "out" ? "-" : "+"}{quantity.toLocaleString("en-IN")}</td>
                                             </tr>
                                          }) : <tr>
                                             <td colSpan="6" className="inventory-ledger__empty">{langPreference?.data_not_found || "Data Not Found"}</td>
                                          </tr>}
                                       </tbody>
                                    </table>
                                 </div>
                              </section>
                           })}
                        </div>
                     }

                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default InventoryReport
